import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { pixelService } from 'services/PixelService';

interface IState extends IStateBase {
  pixel: string;
  affiliatePixel: string;
}

export default class PixelComponent extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      pixel: '',
      affiliatePixel: ''
    };
  }

  componentDidMount() {
    const delay = 4000;

    pixelService.getPixel()
      .delay(delay)
      .bindComponent(this)
      .subscribe((pixel) => {
        this.setState({ pixel });
      });

    pixelService.getParameterPixel()
      .delay(delay)
      .take(1)
      .subscribe((affiliatePixel) => {
        this.setState({ affiliatePixel });
      });
  }

  render() {
    if (!this.state.pixel) {
      return null;
    }

    const { pixel, affiliatePixel } = this.state;

    return (
      <div style={{ display: 'none' }} id='pixel-container'>
        {pixel && <iframe id='pixel-load-trackers' src={pixel} width='1' height='1' frameBorder='0' />}
        {affiliatePixel && <iframe id='pixel-mark-affiliate' src={affiliatePixel} width='1' height='1' frameBorder='0' />}
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/PixelComponent.tsx